import { __awaiter, __decorate, __metadata } from 'tslib';
import { ɵɵdefineInjectable, Injectable, Input, Component, SimpleChange, ViewContainerRef, ComponentFactoryResolver, Injector, NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { every, some, propertyOf, find, forEach, map, castArray, filter, clone, mapValues, isEmpty, forOwn, isFunction } from 'lodash';
import { defer, BehaviorSubject } from 'rxjs';
import { switchAll, tap, catchError } from 'rxjs/operators';
import { ProjectSerializer } from '@dvl-fw/core';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/material/card';

function ItemComponent_mat_card_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-card", 1);
    ɵngcc0.ɵɵelementStart(1, "mat-card-title", 2);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "mat-card-subtitle", 3);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "mat-card-content", 4);
    ɵngcc0.ɵɵelement(6, "dvl-visualization", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const vis_r1 = ctx.ngIf;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.title);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.subtitle);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("data", vis_r1);
} }
function LegendComponent_mat_card_1_dvl_legend_item_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "dvl-legend-item", 6);
} if (rf & 2) {
    const variable_r3 = ctx.$implicit;
    const group_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("project", ctx_r2.project)("visualization", ctx_r2.visualization)("symbol", group_r1.id)("variable", variable_r3)("type", ctx_r2.type)("advanced", ctx_r2.advanced);
} }
function LegendComponent_mat_card_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-card", 2);
    ɵngcc0.ɵɵelementStart(1, "mat-card-title", 3);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "mat-card-content", 4);
    ɵngcc0.ɵɵtemplate(4, LegendComponent_mat_card_1_dvl_legend_item_4_Template, 1, 6, "dvl-legend-item", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const group_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(group_r1.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("data-orientation", ctx_r0.orientation);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", group_r1);
} }
function DvlFwVisualizationComponent_ng_template_0_Template(rf, ctx) { }
let ProjectSerializerService = class ProjectSerializerService {
    constructor( /* TODO: Inject Plugins */) {
        this.registry = ProjectSerializer.defaultRegistry;
    }
    createVisualization(template, data, project) {
        return defer(() => __awaiter(this, void 0, void 0, function* () {
            return yield ProjectSerializer.createVisualization(template, data, project, this.registry);
        }));
    }
    toYAML(project) {
        return defer(() => ProjectSerializer.toYAML(project, this.registry));
    }
    fromYAML(yaml) {
        return defer(() => ProjectSerializer.fromYAML(yaml, this.registry));
    }
    toJSON(project) {
        return defer(() => ProjectSerializer.toJSON(project, this.registry));
    }
    fromJSON(json) {
        return defer(() => ProjectSerializer.fromJSON(json, this.registry));
    }
};
ProjectSerializerService.ɵfac = function ProjectSerializerService_Factory(t) { return new (t || ProjectSerializerService)(); };
ProjectSerializerService.ɵprov = ɵɵdefineInjectable({ factory: function ProjectSerializerService_Factory() { return new ProjectSerializerService(); }, token: ProjectSerializerService, providedIn: "root" });
ProjectSerializerService = __decorate([ __metadata("design:paramtypes", [])
], ProjectSerializerService);

/** Data representing an empty visualization */
const EMPTY_VIS = [undefined];
/**
 * Renderes a single legend with a title and subtitle
 */
let ItemComponent = class ItemComponent {
    constructor(serializer) {
        this.serializer = serializer;
        this.title = undefined;
        this.subtitle = undefined;
        this.template = undefined;
        this.symbolObj = undefined;
        this.variableObj = undefined;
        this.innerVisualization$ = new BehaviorSubject(EMPTY_VIS);
        this.visualization$ = this.innerVisualization$.pipe(switchAll());
    }
    ngOnChanges(changes) {
        const { project, visualization, symbol, variable } = this;
        const checkedValues = [project, visualization, symbol, variable];
        const checkedProperties = ['project', 'visualization', 'symbol', 'variable', 'type', 'advanced'];
        if (!every(checkedValues) || !this.setValues()) {
            this.clear();
        }
        else if (some(checkedProperties, propertyOf(changes))) {
            this.update();
        }
    }
    ngOnDestroy() {
        this.clear();
    }
    update() {
        const legend = this.generateLegend();
        this.innerVisualization$.next(legend);
    }
    clear() {
        this.innerVisualization$.next(EMPTY_VIS);
    }
    setValues() {
        const { visualization, symbol, variable, advanced } = this;
        const symbolOpt = find(visualization.graphicSymbolOptions, ['id', symbol]);
        const variableOpt = symbolOpt && find(symbolOpt.graphicVariableOptions, ({ id, type }) => {
            return id ? id === variable : type === variable;
        });
        const template = this.template = variableOpt && this.selectTemplate(variableOpt);
        const symbolObj = this.symbolObj = visualization.graphicSymbols[symbol];
        const variableObj = this.variableObj = symbolObj && symbolObj.graphicVariables[variable];
        const isDisabled = !advanced && variableOpt && variableOpt.advanced;
        this.title = variableOpt && variableOpt.label;
        this.subtitle = variableObj && `${variableObj.recordSet.label}: ${variableObj.label}`;
        const checkedValues = [!isDisabled, template, symbolObj, variableObj];
        if (every(checkedValues)) {
            return true;
        }
        // Clear internals for consistent state (all or nothing set)
        this.title = this.subtitle = this.template = undefined;
        this.symbolObj = this.variableObj = undefined;
        return false;
    }
    selectTemplate(variableOpt) {
        const { visualization: dynamicVis, staticVisualization: staticVis } = variableOpt;
        switch (this.type) {
            default: /** Fallthrough */
            case 'dynamic-preferred':
                return dynamicVis || staticVis;
            case 'static-preferred':
                return staticVis || dynamicVis;
            case 'dynamic-only':
                return dynamicVis;
            case 'static-only':
                return staticVis;
        }
    }
    generateLegend() {
        const { project, template, symbolObj, variableObj } = this;
        // Snapshot properties used by generateItemsSymbol
        // It is called inside an observable and therefore properties may have changed between
        // this call and the call to generateItemsSymbol
        const snapshot = Object.setPrototypeOf({
            project, template, symbolObj, variableObj
        }, this);
        const preData = {
            id: `legend-item-${template}`, template, properties: {}, graphicSymbols: {}
        };
        if (!template) {
            return EMPTY_VIS;
        }
        return this.serializer.createVisualization(template, preData, null).pipe(tap(vis => vis.graphicSymbols['items'] = snapshot.generateItemsSymbol()), catchError(_error => [EMPTY_VIS]));
    }
    generateItemsSymbol() {
        const { project, template, symbolObj, variableObj } = this;
        const symbol = Object.setPrototypeOf({
            id: 'items', graphicVariables: {}
        }, symbolObj);
        const variables = symbol.graphicVariables;
        // Copy special GraphicVariables
        variables['identifier'] = symbolObj.graphicVariables['identifier'];
        variables[variableObj.type] = variableObj;
        if (template === 'color') {
            variables['color'] = variableObj;
        }
        // Copy GraphicVariables with the same DataVariable
        const sourceDataVariable = variableObj.dataVariable;
        forEach(project.graphicVariables, variable => {
            const { type, dataVariable } = variable;
            if (dataVariable === sourceDataVariable && !variables[type]) {
                variables[type] = variable;
            }
        });
        return symbol;
    }
};
ItemComponent.ɵfac = function ItemComponent_Factory(t) { return new (t || ItemComponent)(ɵngcc0.ɵɵdirectiveInject(ProjectSerializerService)); };
ItemComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ItemComponent, selectors: [["dvl-legend-item"]], inputs: { project: "project", visualization: "visualization", symbol: "symbol", variable: "variable", type: "type", advanced: "advanced" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 3, consts: [["class", "dvl-legend-item container", 4, "ngIf"], [1, "dvl-legend-item", "container"], [1, "title"], [1, "subtitle"], [1, "content"], [3, "data"]], template: function ItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ItemComponent_mat_card_0_Template, 7, 3, "mat-card", 0);
        ɵngcc0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.visualization$));
    } }, directives: function () { return [ɵngcc1.NgIf, ɵngcc2.MatCard, ɵngcc2.MatCardTitle, ɵngcc2.MatCardSubtitle, ɵngcc2.MatCardContent, DvlFwVisualizationComponent]; }, pipes: function () { return [ɵngcc1.AsyncPipe]; }, styles: [".dvl-legend-item.container[_ngcontent-%COMP%]{background-color:#fff;border:1px solid transparent;box-shadow:0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12);box-sizing:border-box;height:12rem;margin:.25rem;min-width:11rem;overflow-y:auto;text-align:center}.dvl-legend-item.container[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#212121;font-size:1rem;font-weight:700}.dvl-legend-item.container[_ngcontent-%COMP%]   .subtitle[_ngcontent-%COMP%]{color:#757575;margin-bottom:.5rem}.dvl-legend-item.container[_ngcontent-%COMP%]     .dvl-static-legend-container{align-items:center;display:flex;justify-content:center;min-height:4.375rem}.dvl-legend-item.container[_ngcontent-%COMP%]     .dvl-static-legend-container svg{height:3rem}"] });
__decorate([
    Input(),
    __metadata("design:type", Object)
], ItemComponent.prototype, "project", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], ItemComponent.prototype, "visualization", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], ItemComponent.prototype, "symbol", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], ItemComponent.prototype, "variable", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], ItemComponent.prototype, "type", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ItemComponent.prototype, "advanced", void 0);
ItemComponent = __decorate([ __metadata("design:paramtypes", [ProjectSerializerService])
], ItemComponent);

let LegendComponent = class LegendComponent {
    constructor() {
        this.groups = [];
    }
    ngOnChanges(changes) {
        const { project, visualization } = this;
        const checkedValues = [project, visualization];
        const checkedProperties = ['visualization', 'symbolGroups'];
        if (!every(checkedValues)) {
            this.clear();
        }
        else if (some(checkedProperties, propertyOf(changes))) {
            this.update();
        }
    }
    ngOnDestroy() {
        this.clear();
    }
    update() {
        const { visualization: { graphicSymbolOptions: symbolOpts }, symbolGroups } = this;
        const ids = new Set(symbolGroups === undefined ? map(symbolOpts, 'id') : castArray(symbolGroups));
        const filteredOpts = filter(symbolOpts, ({ id }) => ids.has(id));
        const groups = map(filteredOpts, this.createGroup);
        const filteredGroups = filter(groups, 'length');
        this.groups = filteredGroups;
    }
    clear() {
        this.groups = [];
    }
    createGroup(symbolOpt) {
        const { id, label, graphicVariableOptions } = symbolOpt;
        const items = filter(map(graphicVariableOptions, opt => opt.id || opt.type));
        return Object.assign(items, { id, label });
    }
};
LegendComponent.ɵfac = function LegendComponent_Factory(t) { return new (t || LegendComponent)(); };
LegendComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: LegendComponent, selectors: [["dvl-legend"]], inputs: { project: "project", visualization: "visualization", symbolGroups: "symbolGroups", orientation: "orientation", type: "type", advanced: "advanced" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [[1, "dvl-legend", "container"], ["class", "group", 4, "ngFor", "ngForOf"], [1, "group"], [1, "title"], [1, "content"], ["class", "item", 3, "project", "visualization", "symbol", "variable", "type", "advanced", 4, "ngFor", "ngForOf"], [1, "item", 3, "project", "visualization", "symbol", "variable", "type", "advanced"]], template: function LegendComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, LegendComponent_mat_card_1_Template, 5, 3, "mat-card", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("data-orientation", ctx.orientation);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.groups);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc2.MatCard, ɵngcc2.MatCardTitle, ɵngcc2.MatCardContent, ItemComponent], styles: [".dvl-legend.container[_ngcontent-%COMP%]{background-color:#f5f5f5;border:1px solid #e0e0e0;border-radius:4px;box-shadow:none;box-sizing:border-box;display:flex;margin:.5rem;overflow:visible;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.dvl-legend.container[data-orientation=vertical][_ngcontent-%COMP%]{flex-direction:column}.dvl-legend.container[_ngcontent-%COMP%]   .group[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#212121;font-size:1rem;font-weight:700}.dvl-legend.container[_ngcontent-%COMP%]   .group[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{display:flex}.dvl-legend.container[_ngcontent-%COMP%]   .group[_ngcontent-%COMP%]   .content[data-orientation=vertical][_ngcontent-%COMP%]{flex-direction:column}"] });
__decorate([
    Input(),
    __metadata("design:type", Object)
], LegendComponent.prototype, "project", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], LegendComponent.prototype, "visualization", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], LegendComponent.prototype, "symbolGroups", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], LegendComponent.prototype, "orientation", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], LegendComponent.prototype, "type", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], LegendComponent.prototype, "advanced", void 0);

class ClonedGraphicSymbol {
    constructor(original) {
        this.original = original;
        this.id = this.original.id;
        this.type = this.original.type;
        this.recordStream = this.original.recordStream;
        this.graphicVariables = clone(this.original.graphicVariables);
    }
    toJSON() { return this.original.toJSON(); }
}
class ClonedVisualization {
    constructor(original) {
        this.original = original;
        this.id = this.original.id;
        this.template = this.original.template;
        this.properties = clone(this.original.properties) || {};
        this.graphicSymbols = mapValues(this.original.graphicSymbols, sym => new ClonedGraphicSymbol(sym)) || {};
        this.component = this.original.component;
        this.graphicSymbolOptions = this.original.graphicSymbolOptions;
    }
    normalize() {
        // TODO: Remove graphic symbols not satisfying options
    }
    toJSON() { return this.original.toJSON(); }
}

let DvlFwVisualizationComponent = class DvlFwVisualizationComponent {
    constructor(viewContainerRef, componentFactoryResolver, injector) {
        this.viewContainerRef = viewContainerRef;
        this.componentFactoryResolver = componentFactoryResolver;
        this.injector = injector;
        this.data = undefined;
    }
    ngOnInit() {
        if (this.data) {
            this.load();
        }
    }
    ngOnChanges(changes) {
        if ('data' in changes) {
            this.onDataChange(changes['data']);
        }
    }
    runDataChangeDetection() {
        this.onDataChange(new SimpleChange(this.currentData, this.data, false));
    }
    onDataChange(change) {
        const { currentValue, previousValue, firstChange } = change;
        if (firstChange) { // Let ngOnInit take care of the first load
            return;
        }
        if (currentValue) {
            if (!previousValue || previousValue.component !== currentValue.component) {
                this.unload();
                this.load();
            }
            else {
                this.update();
            }
        }
        else {
            if (previousValue) {
                this.unload();
            }
        }
    }
    createComponent(componentType) {
        const { componentFactoryResolver, viewContainerRef } = this;
        try {
            const factory = componentFactoryResolver.resolveComponentFactory(componentType);
            const component = viewContainerRef.createComponent(factory, null, this.injector);
            return component;
        }
        catch (error) {
            console.log(`Failed to create visualization component`, error);
            // TODO: Log error
            // TODO: Create default component?
            return undefined;
        }
    }
    load() {
        const data = this.data;
        const componentType = data.component;
        if (!componentType) {
            // TODO: Use logger
            console.log(`Visualization Component is missing for type: ${data.template}`, data);
            return;
        }
        const newComponent = this.createComponent(componentType);
        if (!newComponent) {
            return;
        }
        const clonedData = new ClonedVisualization(data);
        clonedData.normalize();
        newComponent.instance.data = clonedData;
        // TODO: Call lifecycle?
        this.componentRef = newComponent;
        this.currentData = clonedData;
    }
    unload() {
        const { componentRef, viewContainerRef } = this;
        if (!componentRef) {
            return;
        }
        viewContainerRef.clear();
        this.componentRef = undefined;
        this.currentData = undefined;
    }
    update() {
        const { currentData, data } = this;
        const clonedData = new ClonedVisualization(data);
        clonedData.normalize();
        const propDiff = this.diff(clonedData.properties, currentData.properties, (v1, v2) => v1 === v2);
        const symDiff = this.diff(clonedData.graphicSymbols, currentData.graphicSymbols, this.graphicSymbolEquals.bind(this));
        this.applyDiff(currentData.properties, propDiff);
        this.applyDiff(currentData.graphicSymbols, symDiff);
        if (!isEmpty(propDiff)) {
            this.callDvlLifecycleHook('dvlOnPropertyChange', propDiff);
        }
        if (!isEmpty(symDiff)) {
            this.callDvlLifecycleHook('dvlOnGraphicSymbolChange', symDiff);
        }
    }
    diff(newData, oldData, eq) {
        const hasOwnProperty = ({}).hasOwnProperty;
        const changes = Object.create(null);
        forOwn(newData, (value, prop) => {
            if (!hasOwnProperty.call(oldData, prop)) {
                changes[prop] = new SimpleChange(undefined, value, true);
            }
            else if (!eq(value, oldData[prop])) {
                changes[prop] = new SimpleChange(oldData[prop], value, false);
            }
        });
        forOwn(oldData, (value, prop) => {
            if (!hasOwnProperty.call(newData, prop)) {
                changes[prop] = new SimpleChange(value, undefined, false);
            }
        });
        return changes;
    }
    applyDiff(data, diff) {
        forOwn(diff, (change, key) => {
            data[key] = change.currentValue;
        });
    }
    graphicSymbolEquals(sym1, sym2) {
        if (sym1 === undefined || sym2 === undefined) {
            return sym1 === sym2;
        }
        const { id: id1, type: type1, recordStream: rs1, graphicVariables: gv1 } = sym1;
        const { id: id2, type: type2, recordStream: rs2, graphicVariables: gv2 } = sym2;
        if (id1 !== id2 || type1 !== type2 || rs1 !== rs2) {
            return false;
        }
        else {
            const diff = this.diff(gv1, gv2, (v1, v2) => v1 === v2);
            return isEmpty(diff);
        }
    }
    callDvlLifecycleHook(name, ...args) {
        const ref = this.componentRef;
        const instance = ref && ref.instance;
        const hook = instance && instance[name];
        if (isFunction(hook)) {
            hook.apply(instance, args);
        }
    }
};
DvlFwVisualizationComponent.ɵfac = function DvlFwVisualizationComponent_Factory(t) { return new (t || DvlFwVisualizationComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
DvlFwVisualizationComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DvlFwVisualizationComponent, selectors: [["dvl-visualization"]], inputs: { data: "data" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 0, template: function DvlFwVisualizationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DvlFwVisualizationComponent_ng_template_0_Template, 0, 0, "ng-template");
    } }, styles: [".visualization-container .tooltip{border:1px solid #fff;border-radius:4px;box-shadow:1px 2px 4px rgba(0,0,0,.4);margin-left:1.25rem;margin-right:1.25rem;padding:.625rem!important}"] });
__decorate([
    Input(),
    __metadata("design:type", Object)
], DvlFwVisualizationComponent.prototype, "data", void 0);
DvlFwVisualizationComponent = __decorate([ __metadata("design:paramtypes", [ViewContainerRef,
        ComponentFactoryResolver,
        Injector])
], DvlFwVisualizationComponent);

let DvlFwAngularModule = class DvlFwAngularModule {
};
DvlFwAngularModule.ɵfac = function DvlFwAngularModule_Factory(t) { return new (t || DvlFwAngularModule)(); };
DvlFwAngularModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DvlFwAngularModule });
DvlFwAngularModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[BrowserModule, BrowserAnimationsModule, MatCardModule, MatSelectModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ProjectSerializerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ItemComponent, [{
        type: Component,
        args: [{
                selector: 'dvl-legend-item',
                template: "<mat-card class=\"dvl-legend-item container\" *ngIf=\"visualization$ | async as vis\">\n  <mat-card-title class=\"title\">{{ title }}</mat-card-title>\n  <mat-card-subtitle class=\"subtitle\">{{ subtitle }}</mat-card-subtitle>\n  <mat-card-content class=\"content\">\n    <dvl-visualization [data]=\"vis\"></dvl-visualization>\n  </mat-card-content>\n</mat-card>\n",
                styles: [".dvl-legend-item.container{background-color:#fff;border:1px solid transparent;box-shadow:0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12);box-sizing:border-box;height:12rem;margin:.25rem;min-width:11rem;overflow-y:auto;text-align:center}.dvl-legend-item.container .title{color:#212121;font-size:1rem;font-weight:700}.dvl-legend-item.container .subtitle{color:#757575;margin-bottom:.5rem}.dvl-legend-item.container ::ng-deep .dvl-static-legend-container{align-items:center;display:flex;justify-content:center;min-height:4.375rem}.dvl-legend-item.container ::ng-deep .dvl-static-legend-container svg{height:3rem}"]
            }]
    }], function () { return [{ type: ProjectSerializerService }]; }, { project: [{
            type: Input
        }], visualization: [{
            type: Input
        }], symbol: [{
            type: Input
        }], variable: [{
            type: Input
        }], type: [{
            type: Input
        }], advanced: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LegendComponent, [{
        type: Component,
        args: [{
                selector: 'dvl-legend',
                template: "<div class=\"dvl-legend container\" [attr.data-orientation]=\"orientation\">\n  <mat-card *ngFor=\"let group of groups\" class=\"group\">\n    <mat-card-title class=\"title\">{{ group.label }}</mat-card-title>\n    <mat-card-content class=\"content\" [attr.data-orientation]=\"orientation\">\n      <dvl-legend-item *ngFor=\"let variable of group\" class=\"item\" [project]=\"project\" [visualization]=\"visualization\"\n                       [symbol]=\"group.id\" [variable]=\"variable\" [type]=\"type\" [advanced]=\"advanced\">\n      </dvl-legend-item>\n    </mat-card-content>\n  </mat-card>\n</div>\n",
                styles: [".dvl-legend.container{background-color:#f5f5f5;border:1px solid #e0e0e0;border-radius:4px;box-shadow:none;box-sizing:border-box;display:flex;margin:.5rem;overflow:visible;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.dvl-legend.container[data-orientation=vertical]{flex-direction:column}.dvl-legend.container .group .title{color:#212121;font-size:1rem;font-weight:700}.dvl-legend.container .group .content{display:flex}.dvl-legend.container .group .content[data-orientation=vertical]{flex-direction:column}"]
            }]
    }], function () { return []; }, { project: [{
            type: Input
        }], visualization: [{
            type: Input
        }], symbolGroups: [{
            type: Input
        }], orientation: [{
            type: Input
        }], type: [{
            type: Input
        }], advanced: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DvlFwVisualizationComponent, [{
        type: Component,
        args: [{
                selector: 'dvl-visualization',
                template: "<ng-template></ng-template>",
                styles: ["::ng-deep .visualization-container .tooltip{border:1px solid #fff;border-radius:4px;box-shadow:1px 2px 4px rgba(0,0,0,.4);margin-left:1.25rem;margin-right:1.25rem;padding:.625rem!important}"]
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.Injector }]; }, { data: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DvlFwAngularModule, [{
        type: NgModule,
        args: [{
                declarations: [LegendComponent, ItemComponent, DvlFwVisualizationComponent],
                imports: [BrowserModule, BrowserAnimationsModule, MatCardModule, MatSelectModule],
                exports: [LegendComponent, ItemComponent, DvlFwVisualizationComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DvlFwAngularModule, { declarations: function () { return [LegendComponent, ItemComponent, DvlFwVisualizationComponent]; }, imports: function () { return [BrowserModule, BrowserAnimationsModule, MatCardModule, MatSelectModule]; }, exports: function () { return [LegendComponent, ItemComponent, DvlFwVisualizationComponent]; } }); })();

/*
 * Public API Surface of dvl-fw-angular
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DvlFwAngularModule, DvlFwVisualizationComponent, ItemComponent, LegendComponent, ProjectSerializerService };

